import { Switch } from '@heroui/react'
import { isSame, switchSame } from '../lib/i18n/same'
import { useStaffText } from './StaffText'

/** "Same in every language": one value for a brand or a name, never marked missing. */
export function SameSwitch({
  value,
  onChange,
  defaultLang,
  label,
}: {
  value: Record<string, string> | undefined
  onChange: (next: Record<string, string>) => void
  /** The organisation's default customer language: switching off returns the value to it. */
  defaultLang: string
  /** What the switch is about, when the page has several: read by screen readers. */
  label?: string
}) {
  const { say } = useStaffText()
  return (
    <Switch
      className="same-switch"
      size="sm"
      aria-label={label ? `${label} · ${say('content.same')}` : undefined}
      isSelected={isSame(value)}
      onChange={(on) => onChange(switchSame(value, on, defaultLang))}
    >
      <Switch.Content>
        <Switch.Control>
          <Switch.Thumb />
        </Switch.Control>
        <span className="same-switch__label">{say('content.same')}</span>
      </Switch.Content>
    </Switch>
  )
}
